import { HeroHome } from '@/components/HeroHome'
import { ProductCategories } from '@/components/sections/ProductCategories'
import { MethodSteps } from '@/components/sections/MethodSteps'
import { QuoteCTA } from '@/components/sections/QuoteCTA'
import { StrengthPoints } from '@/components/sections/StrengthPoints'

export function Home() {
  return (
    <main>
      <HeroHome />
      <ProductCategories />
      <MethodSteps />
      <QuoteCTA />
      <StrengthPoints />
    </main>
  )
}
